// extracted by mini-css-extract-plugin
export default {"tabBar":"MainLayout_tabBar__mF3Vi","sideBar":"MainLayout_sideBar__4xbue","headerMenu":"MainLayout_headerMenu__J0H0q"};